import { Children, cloneElement, isValidElement } from 'react';
import { Markdown } from '@framework/ui/elements/Markdown';

type Props = {
  body: string;
};

export const ModelCommentBody: React.FC<Props> = ({ body }: Props) => {
  return (
    <div>
      <Markdown
        className="markdown-body text-3xl"
        source={body}
        components={{
          img: ({ node, ...props }) => <img {...props} style={{ width: '100%' }} />,
          // pre はブロックコードのみで呼び出されるため、インラインコードには影響しない。
          // github-markdown-css が pre code に white-space: pre を指定しているため、
          // code 子要素にインラインスタイルを直接注入して上書きする。
          pre: ({ node, children, ...props }) => (
            <pre {...props}>
              {Children.map(children, (child) => {
                if (isValidElement(child) && child.type === 'code') {
                  return cloneElement(child as React.ReactElement<React.HTMLAttributes<HTMLElement>>, {
                    style: { wordBreak: 'break-all', whiteSpace: 'pre-wrap' },
                  });
                }
                return child;
              })}
            </pre>
          ),
        }}
      />
    </div>
  );
};
